import { DateTime } from "luxon";

import { DEFAULT_TIMEZONE } from "../../hooks/useGetSystemTimeZone";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

export type DataEntryDateState = {
  dataEntryDateDateTime: DateTime<true>;
};

export type DataEntryDateActions = {
  setDataEntryDateDateTime: (dataEntryDateDateTime: DateTime<true>) => void;
};

export const getToday = (timeZone: string) =>
  DateTime.now().setZone(timeZone).startOf("day") as DateTime<true>;

export const createDataEntryDateSlice: WaterlyAppStateCreator<DataEntryDateActions, DataEntryDateState> = (
  set,
) => ({
  dataEntryDateDateTime: getToday(DEFAULT_TIMEZONE),
  setDataEntryDateDateTime: (dataEntryDateTime) =>
    set(
      () => ({
        dataEntryDateDateTime: dataEntryDateTime,
      }),
      undefined,
      "dataEntryDate:setDataEntryDateTime",
    ),
});
